/**
 * Which platform family the device belongs to, for the few controls that
 * follow the device's own convention (the "more" menu is ⋯ on Apple devices
 * and ⋮ on Android and Windows; Kurtis, 2026-10-02).
 *
 * Apple = iPhone, iPad and Mac. iPadOS 13+ reports itself as a Mac
 * ("MacIntel"), which is the right answer here, so no touch check is needed
 * (compare `photoShare.js`, which has to tell an iPad from a Mac).
 *
 * Takes a navigator-shaped object so it can be tested; returns false where
 * there is no navigator at all.
 */
export function isAppleDevice(nav = typeof navigator !== 'undefined' ? navigator : null) {
  if (!nav) return false;
  // Chromium browsers: 'macOS', 'Android', 'Windows', 'Chrome OS', 'Linux'
  const hinted = nav.userAgentData?.platform;
  if (hinted) return /^(macOS|iOS)$/i.test(hinted);
  // Safari and Firefox: 'iPhone', 'iPad', 'MacIntel', 'Win32', 'Linux armv8l'
  if (nav.platform) return /^(Mac|iPhone|iPad|iPod)/.test(nav.platform);
  return /iPhone|iPad|iPod|Macintosh/.test(nav.userAgent || '');
}
